<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <div class="container" v-if="ReportData.length > 0">
            <v-row>
              <v-col>Sell: {{ SellTotal.toLocaleString() }}</v-col>
              <v-col>Buy: {{ BuyTotal.toLocaleString() }}</v-col>
              <v-col>Deff: {{ Deff.toLocaleString() }}</v-col>
            </v-row>
          </div>
          <v-card-title>
            <!-- {{ CustomersList }} -->

            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>

          <v-data-table
            :loading="searching"
            :headers="headers"
            :items="ReportData"
            :search="search"
          >
            <template v-slot:item.SourceAmount="{ item }">
              {{ item.SourceType | MoneySigns }}
              {{ item.SourceAmount.toLocaleString() }}
            </template>
            <template v-slot:item.Amount="{ item }">
              {{ item.Amount.toLocaleString() }}
            </template>
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title v-if="fromDate != '' && toDate != ''"
                  >{{ fromDate }} --- {{ toDate }}</v-toolbar-title
                >

                <v-divider class="mx-4" inset vertical></v-divider>
                <div class="flex-grow-1"></div>
                <v-dialog v-model="dialog" max-width="500px" persistent>
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on"
                      >Search by Date
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Search transaction by Date</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-form ref="form" class="mx-5">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                :loading="searching"
                                :disabled="searching"
                                v-model="fromDate"
                                :rules="[v => !!v || 'From Date is required']"
                                required
                                name="FromDate"
                                label="From Date"
                                type="date"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                :loading="searching"
                                :disabled="searching"
                                v-model="toDate"
                                :rules="[v => !!v || 'To Date is required']"
                                required
                                name="ToDate"
                                label="To Date"
                                type="date"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn
                        color="blue darken-1"
                        :disabled="searching"
                        text
                        @click="close"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        :loading="searching"
                        append-icon="mdi-search"
                        text
                        @click="OnSearch"
                        >Search</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// import { allReq } from "@/axiosfiles/axios-outh";
// import axios from "axios";
// import _ from "lodash";

export default {
  data() {
    return {
      searching: false,
      search: "",
      fromDate: "",
      toDate: "",
      headers: [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        { text: "Tran", value: "ExchangeType" },
        { text: "Type", value: "SourceType" },
        { text: "Amount", value: "SourceAmount" },
        { text: "Rate", value: "Rate" },
        { text: "Price", value: "Amount" },
        { text: "User", value: "User" },
        { text: "Info", value: "info" },
        { text: "Ref", value: "Ref" },
      ],
      ReportData: [],
      EmptyMessage: "",
      dialog: false,
    };
  },
  computed: {
    // SellTotal() {
    //   let sell = _.sumBy(this.ReportData, function(val) {
    //     if (val.ExchangeType === "Sell") return val.Amount;
    //   });
    //   return sell || 0;
    // },
    // BuyTotal() {
    //   let buy = _.sumBy(this.ReportData, function(val) {
    //     if (val.ExchangeType === "Buy") return val.Amount;
    //   });
    //   return buy || 0;
    // },
    SellTotal() {
      // let sell = _.sumBy(this.ReportData, function(val) {
      //   if (val.ExchangeType === "Sell") return val.SourceAmount;
      // });
      // return sell || 0;
      return this.ReportData.reduce((total, tran) => {
        if (tran.ExchangeType === "Sell") return total + tran.Amount;
        return total;
      }, 0);
    },
    BuyTotal() {
      // let buy = _.sumBy(this.ReportData, function(val) {
      //   if (val.ExchangeType === "Buy") return val.Amount;
      // });
      // return buy || 0;
      return this.ReportData.reduce((total, tran) => {
        if (tran.ExchangeType === "Buy") return total + tran.Amount;
        return total;
      }, 0);
    },
    Deff() {
      return this.SellTotal - this.BuyTotal;
    },
  },

  methods: {
    TranSactions(from, to) {
      return this.$store.dispatch("INSERT_ONLY", {
        url: "/exchange/transactions",
        data: {
          from,
          to,
        },
      });
    },

    close() {
      this.dialog = false;
    },
    OnSearch() {
      if (this.$refs.form.validate()) {
        this.ReportData = [];

        this.searching = true;
        this.TranSactions(this.fromDate, this.toDate)
          .then(result => {
            this.ReportData = result.data;
            // console.log(this.ReportData);

            this.searching = false;
          })
          .catch(() => {
            // console.log(error);
            this.searching = false;
          });
      }
    },
  },
  created() {
    this.ReportData = [];

    this.searching = true;
    let date = this.Current();
    this.TranSactions(date.Thismonth, date.date)
      .then(result => {
        // this.ReportData = _.sortBy(result.data, "data");
        this.ReportData = result.data.reverse();
        // console.log(this.ReportData);

        this.searching = false;
      })
      .catch(() => {
        // console.log(error);
        this.searching = false;
      });
  },
};
</script>
